'use client';

import { Link } from '@packages/modules/src/Link/Link';
import type { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import { useCustomerRatingsAndReviewPage } from '../../../CustomerRatingsAndReviewsPage/hooks/useCustomerRatingsAndReviewPage/useCustomerRatingsAndReviewPage';

export type LinkToReviewsPageProps = PropsWithChildren & {
  variationId: string;
};

export const LinkToReviewsPage = ({ variationId, children }: LinkToReviewsPageProps) => {
  const { formatMessage } = useIntl();
  const { getUrl } = useCustomerRatingsAndReviewPage();

  const href = getUrl({ variationId, page: '1' });

  return href ? (
    <Link
      href={href}
      aria-label={formatMessage({
        id: 'customerRatings.customerRatingsOverviewCard.LinkToReviewsPage.ariaLabel',
        defaultMessage: 'Alle Bewertungen anzeigen',
      })}
    >
      {children}
    </Link>
  ) : (
    children
  );
};
